import { Translate } from '@chipinside/translate'
import { styled } from '@mui/material/styles'
import { isBoolean, isNil } from 'lodash'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'
import Fonts from '#/styles/Fonts'

const StyledBox = styled('span')(({ color }) => ({
  color,
  fontSize: Fonts.fontSize.SS,
  fontWeight: Fonts.fontWeight.bold,
  whiteSpace: 'nowrap',
}))

const BooleanBadge = ({ invertedColors, onlyText, value }: any) => {
  if (isNil(value)) return <span>-</span>
  const normalizedValue = isBoolean(value) ? value : Number(value)

  const iconType = normalizedValue ? 'mui-check' : 'mui-close'
  const text = normalizedValue ? Translate({ messageKey: 'yes' }) : Translate({ messageKey: 'no' })

  let color

  if (invertedColors) {
    color = normalizedValue ? Colors.feedback.error.color : Colors.feedback.success.color
  } else {
    color = normalizedValue ? Colors.feedback.success.color : Colors.feedback.error.color
  }

  return onlyText ? (
    <StyledBox color={color}>{text}</StyledBox>
  ) : (
    <Icon size="large" name={iconType} style={{ color }} />
  )
}

export default BooleanBadge
